// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarEventFormTabs{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
}

.CalendarEventFormTabs_item{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 13px;
    display: flex;
    align-items: center;
    color: #71717A;
}

.CalendarEventFormTabs_item--active{
    background: #FFA825;
    border-radius: 4.5px;
    padding: 3px 10px;
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarEventFormTabs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;AACf","sourcesContent":[".CalendarEventFormTabs{\n    display: flex;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.CalendarEventFormTabs_item{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 13px;\n    display: flex;\n    align-items: center;\n    color: #71717A;\n}\n\n.CalendarEventFormTabs_item--active{\n    background: #FFA825;\n    border-radius: 4.5px;\n    padding: 3px 10px;\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
